import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

/**
 * Merges multiple class values into a single string of class names.
 *
 * @param inputs - The class values to merge.
 * @returns A string representing the merged class names.
 * eg: cn('bg-red-500', 'text-white') -> 'bg-red-500 text-white'
 */
export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}
